import GeoPositionFormatter from 'src/components/Layouts/GeoPositionFormatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: 'Nombre',
      minWidth: 100,
      sortable: true,
      align: 'left',
      fixed: 'left'
    },
    {
      //prop: 'latitude',
      label: i18n.t('common_words.geo_position'),
      minWidth: 250,
      sortable: true,
      formatter: GeoPositionFormatter,
    },
    /*{
      prop: 'longitude',
      label: 'Longitud',
      sortable: true,
      align: 'left',
    },
    {
      prop: 'altitude',
      label: 'Altitud',
      sortable: true,
      align: 'left',
    },*/
    {
      prop: 'description',
      label: 'Descripción',
      minWidth: 150,
      sortable: true,
      align: 'left',
    },
    {
      prop: 'state',
      label: 'Estado',
      sortable: true,
      align: 'center',
      minWidth: 150,
    },
  ];

  return { Table };
};

export default configTable;
